module.exports = __webpack_public_path__ + "static/media/LogicWedge2_3_drag_3.de46438e.png";